import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import globalConfig from '../../../../../components/Organisms/Form/config'
import { ConfigCompanyDetails } from '../CompanyDetails/types'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

const config = ({ countries, countryTelephoneCodes, formType }: ConfigCompanyDetails & {formType?: string}) => utils.injectTranslation({
  id: 'CommunicationDetailsForm',
  path: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          id: 'CommunicationDetailsForm',
          path: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs',
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr 1fr 1fr',
                gridTemplateAreas:
                  '\'tradingAddressLabel tradingAddressLabel tradingAddressLabel tradingAddressLabel\' \'isTradingAddressDifferent isTradingAddressDifferent isTradingAddressDifferent isTradingAddressDifferent\' \'tradingAddress tradingAddress tradingAddress tradingAddress\' \'tradingCity tradingCity tradingPostCode tradingPostCode\' \'tradingCountry tradingCountry . .\' \'telephoneCountryIndex telephoneCountryIndex tradingTelephoneNo tradingTelephoneNo\' \'emailAddress emailAddress emailAddress emailAddress\' \'companyWebSite companyWebSite companyWebSite companyWebSite\' \'statementEmailAddresses statementEmailAddresses statementEmailAddresses statementEmailAddresses\' ',
                marginBottom: 'auto',
              },
              content: [
                {
                  componentType: 'label',
                  props: {
                    label: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.tradingAddress.label'
                    ),
                    tooltipLabel: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.tradingAddress.tooltipLabel'
                    ),
                    isHeading: true,
                    gridArea: 'tradingAddressLabel',
                    removeEllipsis: true,
                  },
                },
                {
                  componentType: 'radioGroup',
                  transformType: 'stringAndBooleanConversion',
                  props: {
                    name: 'isTradingAddressDifferent',
                    gridArea: 'isTradingAddressDifferent',
                    dataList: [
                      {
                        id: 'isTradingAddressDifferent1',
                        label: t('components.forms.labels.yes'),
                        value: 'true',
                      },
                      {
                        id: 'isTradingAddressDifferent2',
                        label: t('components.forms.labels.no'),
                        value: 'false',
                      },
                    ],
                    required: true,
                    removeLabelEllipsis: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingAddress',
                    gridArea: 'tradingAddress',
                    required: true,
                    isTextarea: true,
                    textAreaHeight: '28px',
                    textAreaPointerEvents: 'auto',
                    resize: 'none',
                    maxlength: formType === 'Deliverable' ? 100 : 250,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingCity',
                    gridArea: 'tradingCity',
                    required: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingPostCode',
                    gridArea: 'tradingPostCode',
                    required: true,
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'telephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'telephoneCountryIndex',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.telephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.telephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'telephoneCountryIndex',
                    required: true,
                    removeEllipsis: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingCountry',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countries,
                    name: 'tradingCountry',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.tradingCountry.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.tradingCountry.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'tradingCountry',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephoneWithMinimum',
                  transformType: 'transformTelephoneNumber',
                  props: {
                    name: 'tradingTelephoneNo',
                    gridArea: 'tradingTelephoneNo',
                    pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'emailAddress',
                    gridArea: 'emailAddress',
                    addSeparatorLine: true,
                    required: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'website',
                  props: {
                    name: 'companyWebSite',
                    gridArea: 'companyWebSite',
                    removeLabelEllipsis: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: '*email',
                  transformType: 'transformRemoveSpaces',
                  props: {
                    name: 'statementEmailAddresses',
                    gridArea: 'statementEmailAddresses',
                    maxlength: 100,
                    isTextarea: true,
                    textAreaHeight: '16px',
                    textAreaPointerEvents: 'auto',
                  },
                },
              ],
            },
          ],
        },
        {
          id: 'CommunicationDetailsForm',
          path: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs',
          componentType: 'grid',
          content: [
            {
              componentType: 'grid',
              props: {
                gridTemplateColumns: '1fr 1fr',
                gridTemplateAreas:
                  '\'managementContactLabel managementContactLabel\' \'managementContactName managementContactName\' \'managementContactPosition managementContactPosition\' \'managementTelephoneCountryIndex managementContactPhoneNo\' \'managementContactEmailAddress managementContactEmailAddress\' \'tradingContactLabel tradingContactLabel\' \'tradingContactName tradingContactName\' \'tradingContactPosition tradingContactPosition\' \'tradingContactTelephoneCountryIndex tradingPhoneNo\' \'tradingEmailAddress tradingEmailAddress\' \'backOfficeContactLabel backOfficeContactLabel\' \'backOfficeContactName backOfficeContactName\' \'backOfficeContactPosition backOfficeContactPosition\' \'backOfficeTelephoneCountryIndex backOfficePhoneNo\' \'backOfficeEmailAddress backOfficeEmailAddress\' \'complianceContactLabel complianceContactLabel\' \'complianceContactName complianceContactName\' \'complianceContactPosition complianceContactPosition\' \'complianceTelephoneCountryIndex compliancePhoneNo\' \'complianceEmailAddress complianceEmailAddress\'',
              },
              content: [
                {
                  componentType: 'label',
                  props: {
                    label: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.managementContact.label'
                    ),
                    isHeading: true,
                    gridArea: 'managementContactLabel',
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'managementContactName',
                    required: true,
                    gridArea: 'managementContactName',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'managementContactPosition',
                    required: true,
                    gridArea: 'managementContactPosition',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'managementTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'managementTelephoneCountryIndex',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.managementTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.managementTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'managementTelephoneCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationManagementTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephoneWithMinimum',
                  transformType: 'transformTelephoneNumber',
                  props: {
                    name: 'managementContactPhoneNo',
                    required: true,
                    gridArea: 'managementContactPhoneNo',
                    pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'managementContactEmailAddress',
                    gridArea: 'managementContactEmailAddress',
                    required: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'label',
                  props: {
                    label: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.tradingContact.label'
                    ),
                    isHeading: true,
                    gridArea: 'tradingContactLabel',
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingContactName',
                    required: true,
                    gridArea: 'tradingContactName',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingContactPosition',
                    required: true,
                    gridArea: 'tradingContactPosition',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'tradingContactTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'tradingContactTelephoneCountryIndex',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.tradingContactTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.tradingContactTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'tradingContactTelephoneCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationTradingContactTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephoneWithMinimum',
                  transformType: 'transformTelephoneNumber',
                  props: {
                    name: 'tradingPhoneNo',
                    required: true,
                    gridArea: 'tradingPhoneNo',
                    pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'tradingEmailAddress',
                    gridArea: 'tradingEmailAddress',
                    required: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'label',
                  props: {
                    label: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.backOfficeContact.label'
                    ),
                    isHeading: true,
                    gridArea: 'backOfficeContactLabel',
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'backOfficeContactName',
                    required: true,
                    gridArea: 'backOfficeContactName',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'backOfficeContactPosition',
                    required: true,
                    gridArea: 'backOfficeContactPosition',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'backOfficeTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'backOfficeTelephoneCountryIndex',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.backOfficeTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.backOfficeTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'backOfficeTelephoneCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationBackOfficeTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephoneWithMinimum',
                  transformType: 'transformTelephoneNumber',
                  props: {
                    name: 'backOfficePhoneNo',
                    required: true,
                    gridArea: 'backOfficePhoneNo',
                    pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'backOfficeEmailAddress',
                    gridArea: 'backOfficeEmailAddress',
                    required: true,
                    maxlength: 100,
                  },
                },
                {
                  componentType: 'label',
                  props: {
                    label: t(
                      'onboarding.forms.CorporateAccount.CommunicationDetailsForm.labels.complianceContact.label'
                    ),
                    isHeading: true,
                    gridArea: 'complianceContactLabel',
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'complianceContactName',
                    required: true,
                    gridArea: 'complianceContactName',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'complianceContactPosition',
                    required: true,
                    gridArea: 'complianceContactPosition',
                    maxlength: formType === 'Deliverable' ? 100 : 50,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'complianceTelephoneCountryIndex',
                    required: true,
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: countryTelephoneCodes,
                    name: 'complianceTelephoneCountryIndex',
                    label: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.complianceTelephoneCountryIndex.label',
                    placeholder: 'onboarding.forms.CorporateAccount.CommunicationDetailsForm.inputs.complianceTelephoneCountryIndex.placeholder',
                    wrapperMinHeight: '91px',
                    gridArea: 'complianceTelephoneCountryIndex',
                    required: true,
                    filter: true,
                    ...props
                  })
                },
                {
                  componentType: 'input',
                  transformType: 'transformValidationTelephoneCodePlusNumber',
                  props: {
                    name: 'validationComplianceTelephoneCountryIndex',
                    show: false,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'telephoneWithMinimum',
                  transformType: 'transformTelephoneNumber',
                  props: {
                    name: 'compliancePhoneNo',
                    required: true,
                    gridArea: 'compliancePhoneNo',
                    pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'complianceEmailAddress',
                    gridArea: 'complianceEmailAddress',
                    required: true,
                    maxlength: 100,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
})

export default config
